import $ from 'swiper/esm/utils/dom';

let internals = {
    audio: null,

    init: function () {
        $('.audio').on('click', function (e) {
            let current = null;
            if (internals.audio !== null) {
                internals.audio.pause();
                $('.speech__icon--playing').each(function (el) {
                    el.classList.remove('speech__icon--playing');
                    current = el;
                });
            }
            if (typeof Audio !== undefined && current !== e.target) {
                let _audio = new Audio(e.target.getAttribute('data-audio'));
                _audio.play();
                _audio.addEventListener('ended', function () {
                    e.target.classList.remove('speech__icon--playing')
                });
                e.target.classList.add('speech__icon--playing')
                internals.audio = _audio;
            }

        });
    }
}

internals.init();

